import type React from 'react';

import * as demoTutorialComponents from 'bundles/tutorials/content-components/demo-tutorial';
import * as propVsStateComponents from 'bundles/tutorials/content-components/props-vs-state';

const TUTORIAL_SLUG_TO_CONTENT_COMPONENTS_MAPPING: Record<string, Record<string, React.ComponentType<$TSFixMe>>> = {
  'demo-tutorial': demoTutorialComponents,
  'props-vs-state': propVsStateComponents,
};

const getContentComponents = (tutorialSlug: string) => {
  return TUTORIAL_SLUG_TO_CONTENT_COMPONENTS_MAPPING[tutorialSlug];
};

export default getContentComponents;
